import { connect } from 'react-redux';
import Inbox from './Inbox';
import {
    getInboxListBegin,
    applyInboxFilters,
    getInboxSearchConfiguredFormBegin,
    setInboxFilterSelections,
    updateInboxStatusBegin,
} from '../../store/actions/inbox.actions';

import {
    getLoadMore,
    getInboxList,
    getInboxCount,
    getInboxSearchForm,
    getInboxListLoading,
    getInboxSearchFormLoadingStatus,
    getInboxFilterSelections,
} from '../../store/selectors/inbox.selectors';

const mapStateToProps = (state: any) => {
    const hasMore = getLoadMore(state);
    const inboxList = getInboxList(state);
    const inboxCount = getInboxCount(state);
    const isLoading = getInboxListLoading(state);
    const inboxSearchForm = getInboxSearchForm(state);
    const isInboxSearchFormLoading = getInboxSearchFormLoadingStatus(state);
    const filterSelections = getInboxFilterSelections(state);

    return {
        hasMore,
        isLoading,
        inboxList,
        inboxCount,
        inboxSearchForm,
        isInboxSearchFormLoading,
        filterSelections,
    };
};

const mapDispatchToProps = {
    applyInboxFilters,
    getInboxList: getInboxListBegin,
    getInboxSearchForm: getInboxSearchConfiguredFormBegin,
    setFilterSelections: setInboxFilterSelections,
    updateInboxStatus: updateInboxStatusBegin,
};

export default connect(mapStateToProps, mapDispatchToProps)(Inbox);
